import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    name: 'home',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "home" */ '@/views/home'),
  },
  {
    path: '/member',
    name: 'member',
    component: () => import(/* webpackChunkName: "member" */ '@/views/member'),
  },
  {
    path: '/activity/invite',
    name: 'activityInvite',
    component: () => import(/* webpackChunkName: "activity" */ '@/views/activity/ActivityInvite'),
  },
  {
    path: '/activity',
    name: 'activity',
    component: () => import(/* webpackChunkName: "activity" */ '@/views/activity'),
  },
  {
    path: '/activity-share',
    name: 'activityShare',
    component: () => import(/* webpackChunkName: "activity-share" */ '@/views/activity/share.vue'),
  },
  {
    path: '/worth',
    name: 'worth',
    component: () => import(/* webpackChunkName: "member" */ '@/views/worth'),
  },
  {
    path: '/interior',
    name: 'interior',
    component: () => import(/* webpackChunkName: "interior" */ '@/views/interior'),
  },
  {
    path: '/skip',
    name: 'skip',
    component: () => import(/* webpackChunkName: "skip" */ '@/views/skip'),
  },
  {
    path: '/normal',
    name: 'normal',
    component: () => import(/* webpackChunkName: "member" */ '@/views/normal'),
  },

  {
    path: '/download',
    name: 'download',
    component: () => import(/* webpackChunkName: "download" */ '@/views/download'),
  },

  {
    path: '/promotion',
    name: 'promotion',
    component: () => import(/* webpackChunkName: "promotion" */ '@/views/promotion'),
  },
  {
    path: '/yshapp/work',
    name: 'work',
    component: () => import(/* webpackChunkName: "work" */ '@/views/work'),
  },
  {
    path: '/work',
    redirect: '/yshapp/work',
  },
  {
    path: '/yshapp/bluebook',
    component: () => import(/* webpackChunkName: "work" */ '@/views/bluebook'),
  },
  {
    path: '/bluebook',
    redirect: '/yshapp/bluebook',
  },
  {
    path: '/yshapp/popularize',
    name: 'popularize',
    component: () => import(/* webpackChunkName: "work" */ '@/views/popularize'),
  },
  {
    path: '/activation',
    name: 'activation',
    component: () => import(/* webpackChunkName: "activation" */ '@/views/activation'),
  },
  {
    path: '/official',
    name: 'official',
    component: () => import(/* webpackChunkName: "official" */ '@/views/official'),
  },
  {
    path: '/enter',
    name: 'enter',
    component: () => import(/* webpackChunkName: "enter" */ '@/views/enter/enter'),
  },
  {
    path: '/indroduce',
    name: 'indroduce',
    component: () => import(/* webpackChunkName: "indroduce" */ '@/views/enter/indroduce'),
  },
  {
    path: '/socialSettlement',
    name: 'socialSettlement',
    component: () => import(/* webpackChunkName: "socialSettlement" */ '@/views/agreement/socialSettlement'),
  },
  {
    path: '/gxSocialSettlement',
    name: 'gxSocialSettlement',
    component: () => import(/* webpackChunkName: "socialSettlement" */ '@/views/agreement/gxSocialSettlement'),
  },
  {
    path: '/userAgreement',
    name: 'userAgreement',
    component: () => import(/* webpackChunkName: "userAgreement" */ '@/views/agreement/userAgreement'),
  },
  {
    path: '/ysCardAgreement',
    name: 'ysCardAgreement',
    component: () => import(/* webpackChunkName: "userAgreement" */ '@/views/agreement/ysCardAgreement'),
  },
  {
    path: '/privacyPolicy',
    name: 'privacyPolicy',
    component: () => import(/* webpackChunkName: "privacyPolicy" */ '@/views/agreement/privacyPolicy'),
  },
  {
    path: '/thirdpartySdk',
    name: 'thirdpartySdk',
    component: () => import(/* webpackChunkName: "thirdpartySdk" */ '@/views/agreement/thirdpartySdk'),
  },
  {
    path: '/yshapp',
    name: 'yshapp',
    component: () => import(/* webpackChunkName: "yshapp" */ '@/views/yshapp'),
  },
  {
    path: '/phoneActivity',
    name: 'phoneActivity',
    component: () => import(/* webpackChunkName: "yshapp" */ '@/views/landing/phoneActivity'),
  },
  {
    path: '/yyds-investment',
    name: 'yydsInvestment',
    component: () => import(/* webpackChunkName: "yshapp" */ '@/views/yydsInvestment/index'),
  },
  {
    path: '/yyds-investment-success',
    name: 'yyds-investment-success',
    meta: { title: '提交成功' },
    component: () => import(/* webpackChunkName: "yshapp" */ '@/views/yydsInvestment/success'),
  },
  {
    path: '/recruitment',
    name: 'recruitment',
    component: () => import(/* webpackChunkName: "member" */ '@/views/recruitment'),
  },
  {
    path: '/chamberEnter',
    name: 'chamberEnter',
    component: () => import(/* webpackChunkName: "member" */ '@/views/enter/chamberEnter'),
  },
  {
    path: '/ysh/guests',
    name: 'yshGuests',
    component: () => import(/* webpackChunkName: "yshGuests" */ '@/views/yshGuests/yshGuests.vue'),
  },
  {
    path: '/album',
    name: 'album',
    component: () => import(/* webpackChunkName: "album" */ '@/views/album/index.vue'),
  },
  {
    path: '/member/benefits',
    name: 'memberBenefits',
    component: () => import(/* webpackChunkName: "member" */ '@/views/memberBenefits/memberBenefits.vue'),
  },
  {
    path: '/yscard',
    name: 'yscard',
    component: () => import(/* webpackChunkName: "member" */ '@/views/yscard/index'),
  },
  {
    path: '/preview/home',
    name: 'previewHome',
    component: () => import(/* webpackChunkName: "preview" */ '@/views/preview/Home'),
  },
  {
    path: '/preview/page',
    name: 'previewHome',
    component: () => import(/* webpackChunkName: "preview" */ '@/views/preview/Pageview'),
  },
  {
    path: '/exceptionPage',
    name: 'exceptionPage',
    component: () => import(/* webpackChunkName: "exceptionPage" */ '@/views/exceptionPage/ExceptionPage'),
  },
  {
    path: '/chain-claim-rules',
    name: 'chainClaimRules',
    component: () => import(/* webpackChunkName: "member" */ '@/views/yscard/chain-claim-rules'),
  },
]

const router = new VueRouter({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes,
})

export default router
